export const getMobileGridTemplateAreas = (numberOfImages: number): string | null => {
  switch (numberOfImages) {
    case 1:
      return `
        "dropdown dropdown"
        "text text"
        "text text"
        "primaryImage primaryImage"
        "cta cta"
        "secondImage secondImage"
        "bulletPoints bulletPoints"
        `;
    case 2:
      return `
        "dropdown dropdown"
        "text text"
        "text text"
        "primaryImage primaryImage"
        "cta cta"
        "secondImage secondImage"
        "bulletPoints bulletPoints"
        `;
    case 3:
      return `
        "dropdown dropdown"
        "text text"
        "text text"
        "primaryImage primaryImage"
        "cta cta"
        "secondImage secondImage"
        "bulletPoints bulletPoints"
        "thirdImage fourthImage"
        `;
    default:
      return null;
  }
};

export const getTabletGridTemplateAreas = (numberOfImages: number): string | null => {
  switch (numberOfImages) {
    case 1:
      return `
        "dropdown secondImage secondImage"
        "text secondImage secondImage"
        "primaryImage bulletPoints bulletPoints"
        "primaryImage cta cta"
      `;
    case 3:
      return `
        "dropdown thirdImage"
        "text thirdImage"
        "primaryImage bulletPoints"
        "primaryImage fourthImage"
        "secondImage fourthImage"
        "secondImage cta"
        `;

    default:
      return null;
  }
};

export const getDesktopGridTemplateAreas = (numberOfImages: number): string | null => {
  switch (numberOfImages) {
    case 1:
      return `
        "dropdown secondImage secondImage"
        "text secondImage secondImage"
        "text secondImage secondImage"
        "primaryImage secondImage secondImage"
        "primaryImage bulletPoints cta"
      `;
    case 2:
      return `
        "dropdown bulletPoints thirdImage"
        "text secondImage thirdImage"
        "text secondImage thirdImage"
        "primaryImage secondImage thirdImage"
        "primaryImage secondImage cta"
        `;
    case 3:
      return `
        "dropdown thirdImage fourthImage"
        "text thirdImage fourthImage"
        "text thirdImage fourthImage"
        "primaryImage bulletPoints fourthImage"
        "primaryImage secondImage cta"
      `;
    default:
      return null;
  }
};

export type ProductSpotlight = Queries.QuickShopProductFragment & { content: Queries.ProductCardFragmentFragment };
export type BundleSpotlight = Queries.QuickShopProductFragment & { content: Queries.BundleCardFragment };
export type KitSpotlight = Queries.QuickShopProductFragment & { content: Queries.KitCardFragmentFragment };

export const isProductSpotlight = (spotlight: any): spotlight is ProductSpotlight =>
  spotlight.content?.__typename === 'ContentfulProduct';
export const isBundleSpotlight = (spotlight: any): spotlight is BundleSpotlight =>
  spotlight.content?.__typename === 'ContentfulBundle';
export const isKitSpotlight = (spotlight: any): spotlight is KitSpotlight =>
  spotlight.content?.__typename === 'ContentfulKit';
